import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import { Autocomplete } from "@material-ui/lab";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";

const AddEditAircraftFamily = ({ params, toggleModalFn, addEditAircraftFamily, getResponseBack, modeType }) => {
    const [data, setData] = useState(addEditAircraftFamily?.data);
    const [error, setError] = useState({ modal: false, data: null })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [manufacturersInfo, setManufacturersInfo] = useState([]);

    useEffect(() => {
            if (modeType === 'add' || modeType === 'edit') {
                getManufacturers();
            }
        }, []);

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }

    const getManufacturers = () => {
        globalGetService(`config-data/manufacturers/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let manufacturersInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        manufacturersInfo.push({ id: item?.id, name: item?.name })
                    });
                    setManufacturersInfo(manufacturersInfo);
                }
            })
    }

    const isDataChanged = () => {
        const originalData = addEditAircraftFamily?.data || {};
        return(
            data?.name !== originalData?.name ||
            data?.manufacturer?.id !== originalData?.manufacturer?.id ||
            data?.remarks !== originalData?.remarks
        )
    }

    const onAddEditAircraftFamily = () => {

        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter Aircraft Family Name',
            manufacturer: data?.manufacturer ? '' : 'Please select Manufacturer'
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);

            let payload = Object.assign({}, data);

            payload = {
                id:payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                manufacturer: payload?.manufacturer ? payload?.manufacturer : null,
                ac_type: payload?.ac_type ? payload?.ac_type : null,
                remarks: payload?.remarks ? payload?.remarks : null,
            }

            const apiUrl = data?.id ? `config-data/aircraft-family/bulk-update/` : `config-data/aircraft-family/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Aircraft Family Updated Successfully' : 'Aircraft Family Added Successfully',
                            page_title: 'Config Data : Aircraft Family',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Aircraft Family Updation Failed' : 'Aircraft Family Added Failed',
                            page_title: 'Config Data : Aircraft Family',
                            event_type: data?.id ? 'Item Updation failed' : 'Item Add failed',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }

    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit' : modeType === 'view' ? 'Veiw' : 'Add'} Aircraft Family
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    options={(manufacturersInfo || []).filter((item) => item.id !== data?.manufacturer?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="manufacturer"
                                    disabled={modeType === 'view'}
                                    value={data?.manufacturer || null}
                                    onChange={(e, value) => onFieldChange('manufacturer', value)}
                                    renderInput={params => <TextField placeholder={'Please select Manufacturer'}  {...params} label={'Manufacturer'} error={error?.manufacturer || ''} helperText={error?.manufacturer || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    onFocus={() => setError({ ...error, manufacturer: '' })}
                                />
                            </Grid>
                            { modeType === 'view' ?
                              <Grid item md={12} >
                                    <TextField
                                        name='ac_type'
                                        label='Aircraft Type'
                                        disabled
                                        value={data?.ac_types?.map((item) => item.name).join(', ') || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                            </Grid> : null }
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Family', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Aircraft Family form` }) }} color='primary' size='small' variant='outlined'>{modeType === 'view' ? 'Close' : 'Cancel'}</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditAircraftFamily(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Family', item_type: 'Save Button ', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Aircraft Family form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item}
                />)}
        </>
    )
}
export default AddEditAircraftFamily;